import { useMutation, useQueryClient } from 'libs/query'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useTranslation } from 'libs/i18n'
import { queryKeys } from 'config/queryKeys'

type UseDeleteBulkRentalMutationProps = {
	onSettled: () => void
}

export const useDeleteBulkRentalMutation = ({ onSettled }: UseDeleteBulkRentalMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: bulkDeleteMutation } = useMutation({
		mutationFn: (checkedRentals: number[]) => {
			// TODO: change to apiRoutes
			return axiosPrivate.post('/rentals/bulk_delete/', { ids: checkedRentals })
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.rentals.all })

			useToast({
				type: 'success',
				message: t('Rentals deleted')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled
	})

	return {
		bulkDeleteMutation
	}
}
